import { clientSubscriptionApi } from '../api';

export const useClientSubscription = () => {
  return clientSubscriptionApi.endpoints.getBillingSubscription.useQuery();
};
